var React = require('react');

function CarouselPrev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 1L1.54 16.28C1.22 16.7067 1.22 17.2933 1.54 17.72L13 33","stroke":"#CCCCCC","strokeWidth":"1.5","strokeLinecap":"round"}));
}

CarouselPrev.defaultProps = {"width":"12","height":"32","viewBox":"0 0 14 34","fill":"none"};

module.exports = CarouselPrev;

CarouselPrev.default = CarouselPrev;
